module.exports = __webpack_public_path__ + "static/media/Trade Gothic L-01.2a934e07.svg";